import { Link } from 'react-router-dom';
import Icon from '@components/common/Icon';

const AcademicsSection = () => {
  return (
    <section
      className="py-16 sm:py-20 px-4 md:px-4"
      style={{ backgroundColor: 'var(--color-theme-2)' }}
    >
      <div className="container mx-auto max-w-7xl">
        <h2
          className="text-3xl sm:text-4xl font-heading font-bold text-center mb-8 sm:mb-12 tracking-tight"
          style={{ color: 'var(--color-heading)' }}
        >
          Academics
        </h2>
        {/* Single centered card */}
        <div className="flex justify-center max-w-2xl mx-auto">
          <Link to="/academics" className="group h-full w-full">
            <div
              className="h-full flex flex-col p-6 sm:p-8 rounded-xl border transition-all duration-200 hover:shadow-card-hover shadow-card"
              style={{
                backgroundColor: 'var(--color-card-bg)',
                borderColor: 'var(--color-card-border)'
              }}
            >
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: 'var(--color-theme-2)' }}
                >
                  <Icon name="academics" size="lg" style={{ color: 'var(--color-icon-default)' }} />
                </div>
                <h3
                  className="text-xl font-bold"
                  style={{ color: 'var(--color-heading)' }}
                >
                  Academic Achievements
                </h3>
              </div>
              <p
                className="mb-4 text-base"
                style={{ color: 'var(--color-card-text)' }}
              >
                Recognized for academic excellence and independent learning at the International School Manila:
              </p>
              <ul className="text-sm space-y-3 mb-6 flex-1" style={{ color: 'var(--color-muted)' }}>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>AP Scholar:</span> Distinction in 5/5 subjects</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>High Honors Graduate:</span> GPA 6.5+</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 flex-shrink-0" style={{ color: 'var(--color-muted)' }}>•</span>
                  <span><span className="font-semibold" style={{ color: 'var(--color-heading)' }}>Honor Societies:</span> Multiple distinctions</span>
                </li>
              </ul>
              <div
                className="font-medium group-hover:translate-x-1 transition-transform inline-flex items-center gap-1"
                style={{ color: 'var(--color-link)' }}
              >
                Learn More →
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AcademicsSection;
